import React from 'react'

function Activities() {
    return (
        <>
            <>
            <div class="row row-cols-1 row-cols-md-3 g-4 mx-5 mt-4" >
                <div class="col" style={{ width: '18rem' }} >
                    <div class="card h-100">
                        <img src="/images/activies/1try.jpg" class="card-img-top" alt="..." />
                        <div class="card-body text-center text-center" >
                            <h5 class="card-title">Ooty</h5>
                            <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                        </div>
                    </div>
                </div>
                <div class="col" style={{ width: '18rem' }} >
                    <div class="card h-100">
                        <img src="/images/activies/2try.jpg" class="card-img-top" alt="..." />
                        <div class="card-body text-center">
                            <h5 class="card-title">Rajasthan</h5>
                            <p class="card-text">Rajasthan is a state in northern India. It covers 342,239 square kilometres or 10.4 percent of India's total geographical area. It is the largest Indian state by area and the seventh largest by population.</p>
                        </div>
                    </div>
                </div>
                <div class="col" style={{ width: '18rem' }} >
                    <div class="card h-100">
                        <img src="/images/activies/3try.jpg" class="card-img-top" alt="..." />
                        <div class="card-body text-center">
                            <h5 class="card-title">Gujrat</h5>
                            <p class="card-text">Gujarat is a state on the western coast of India with a coastline of 1,600 km – most of which lies on the Kathiawar peninsula – and a population of 60.4 million. It is the fifth-largest Indian state by area and the ninth-largest state by population</p>
                        </div>
                    </div>
                </div>
                <div class="col" style={{ width: '18rem' }} >
                    <div class="card h-100">
                        <img src="/images/activies/4try.jpg" class="card-img-top" alt="..." />
                        <div class="card-body text-center">
                            <h5 class="card-title">Banglore</h5>
                            <p class="card-text">Bengaluru (also called Bangalore) is the capital of India's southern Karnataka state. The center of India's high-tech industry, the city is also known for its parks and nightlife.</p>
                        </div>
                    </div>
                </div>

                <div class="col" style={{ width: '18rem' }}  >
                    <div class="card h-100">
                        <img src="/images/activies/5try.jpg" class="card-img-top" alt="..." />
                        <div class="card-body text-center">
                            <h5 class="card-title">Vellore</h5>
                            <p class="card-text">Vellore is a city in the state of Tamil Nadu, in southern India. It's known for 16th-century Vellore Fort, with its imposing granite walls and surrounding moat. Inside the fort, the Jalakandeswarar Temple features many ornate sculptures.</p>
                        </div>
                    </div>
                </div>
                <div class="col " style={{ width: '18rem' }} >
                    <div class="card h-100">
                        <img src="/images/activies/6try.jpg" class="card-img-top" alt="..." />
                        <div class="card-body text-center">
                            <h5 class="card-title">Maharashtra</h5>
                            <p class="card-text">Maharashtra, abbr. MH or Maha is a state in the western and central peninsular region of India occupying a substantial portion of the Deccan Plateau. </p>
                        </div>
                    </div>
                </div>
                <div class="col " style={{ width: '18rem' }} >
                    <div class="card h-100">
                        <img src="/images/activies/7try.jpg" class="card-img-top" alt="..." />
                        <div class="card-body text-center">
                            <h5 class="card-title">Goa</h5>
                            <p class="card-text">Goa is a state in western India with coastlines stretching along the Arabian Sea.Its long history as a Portuguese colony prior to 1961 is evident in its preserved 17th-century churches and the area’s tropical spice plantations. </p>
                        </div>
                    </div>
                </div>
                <div class="col " style={{ width: '18rem' }} >
                    <div class="card h-100">
                        <img src="/images/activies/8try.jpg" class="card-img-top" alt="..." />
                        <div class="card-body text-center">
                            <h5 class="card-title">Assam</h5>
                            <p class="card-text">Assam is a state in northeastern India known for its wildlife, archeological sites and tea plantations. In the west, Guwahati, Assam’s largest city, features silk bazaars and the hilltop Kamakhya Temple.</p>
                        </div>
                    </div>
                </div>


            </div>
        </>
        </>
    )
}

export default Activities
